/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { MaterialModule } from './material/material.module';
import { AppRoutingModule } from './app-routing.module';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ChartsModule } from 'ng2-charts';
import { DecimalPipe } from '@angular/common';
import {FileUploadModule} from 'ng2-file-upload';
import { EditorModule } from '@tinymce/tinymce-angular';

import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';


import {
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbWindowModule,
  NbCardModule,
} from '@nebular/theme';


//Compents
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { PagesComponent } from './pages/pages.component';
import { DashboardComponent } from './dashboard/dashboard.component';

import { CompanyProfileComponent } from './master-files/company-profile/company-profile.component';
import { AddCustomerComponent } from './master-files/customer-master/add-customer/add-customer.component';
import { ViewCustomersComponent } from './master-files/customer-master/view-customers/view-customers.component';
import { AddSupplierComponent } from './master-files/supplier-master/add-supplier/add-supplier.component';
import { ViewSupplierComponent } from './master-files/supplier-master/view-supplier/view-supplier.component';
import { EmployeeComponent } from './master-files/employee-master/employee/employee.component';
import { EmployeeListComponent } from './master-files/employee-master/employee-list/employee-list.component';
import { FixedAssetComponent } from './master-files/fixed-asset/fixed-asset/fixed-asset.component';
import { FixedAssetListComponent } from './master-files/fixed-asset/fixed-asset-list/fixed-asset-list.component';
import { RoomDetailsComponent } from './master-files/room-details/room-details/room-details.component';
import { RoomDetailsListComponent } from './master-files/room-details/room-details-list/room-details-list.component';
import { VehicleRegisterComponent } from './master-files/vehicle-register/vehicle-register/vehicle-register.component';
import { VehicleRegisterListComponent } from './master-files/vehicle-register/vehicle-register-list/vehicle-register-list.component';

import { ItemComponent } from './products/item-master/item/item.component';
import { ItemListComponent } from './products/item-master/item-list/item-list.component';
import { ItemCategoryComponent } from './products/item-category/item-category.component';


import { PurchaseOrderComponent } from './purchase/purchase-order/purchase-order/purchase-order.component';
import { PurchaseOrderListComponent } from './purchase/purchase-order/purchase-order-list/purchase-order-list.component';
import { PurchaseInvoiceComponent} from './purchase/purchase-invoice/purchase-invoice/purchase-invoice.component';
import { PurchaseInvoiceListComponent } from './purchase/purchase-invoice/purchase-invoice-list/purchase-invoice-list.component';
import { PurchaseReturnComponent } from './purchase/purchase-return/purchase-return/purchase-return.component';
import { PurchaseReturnListComponent } from './purchase/purchase-return/purchase-return-list/purchase-return-list.component';
import { PaymentComponent } from './purchase/payment/payment/payment.component';
import { PaymentListComponent } from './purchase/payment/payment-list/payment-list.component';

import { BarInvoiceComponent } from './sale/bar-invoice/bar-invoice/bar-invoice.component';
import { BarInvoiceListComponent } from './sale/bar-invoice/bar-invoice-list/bar-invoice-list.component';
import { QuotationComponent } from './sale/quotation/quotation/quotation.component';
import { QuotationListComponent } from './sale/quotation/quotation-list/quotation-list.component';
import { AddInvoiceComponent } from './sale/invoice/add-invoice/add-invoice.component';
import { InvoiceListComponent } from './sale/invoice/invoice-list/invoice-list.component';
import { ReceiptComponent } from './sale/receipt/receipt/receipt.component';
import { ReceiptListComponent } from './sale/receipt/receipt-list/receipt-list.component';

import { ExpenseComponent } from './expenses/expense/expense/expense.component';
import { ExpenseListComponent } from './expenses/expense/expense-list/expense-list.component';

import { BankAccountsComponent } from './banks/bank-accounts/bank-account/bank-accounts.component';
import { ChequeListComponent } from './banks/cheques/cheque-list.component';
import { CashBankEntryComponent } from './banks/cash-bank-entry/cash-bank-entry/cash-bank-entry.component';
import { CashBankEntryListComponent } from './banks/cash-bank-entry/cash-bank-entry-list/cash-bank-entry-list.component';
import { CashFlowComponent } from './banks/cash-flow/cash-flow.component';


import { UsersComponent } from './users/users/users.component';
import { UserListComponent } from './users/users/user-list.component';
import { UserTypesComponent } from './users/user-types/user-types.component';
import { UserPermissionComponent } from './users/user-permission/user-permission.component';
import { SettingsComponent } from './settings/settings/settings.component';
import { ChangePasswordComponent } from './settings/change-password/change-password.component';
import { BankAccountListComponent } from './banks/bank-accounts/bank-account-list/bank-account-list.component';
import { FileUploadComponent } from './file-upload/file-upload.component';

import { MatConfirmDialogComponent } from './mat-confirm-dialog/mat-confirm-dialog.component';


//Reports

import { CustomerOutstandingReportComponent } from './reports/customer-outstanding-report/customer-outstanding-report.component';
import { SupplierOutstandingReportComponent } from './reports/supplier-outstanding-report/supplier-outstanding-report.component';
import { SalesReportComponent } from './reports/sales-report/sales-report.component';
import { IncomeStatementComponent } from './reports/income-statement/income-statement.component';
import { ExpensesAnalysisReportComponent } from './reports/expenses-analysis-report/expenses-analysis-report.component';
import { InventoryBalanceReportComponent } from './reports/inventory-balance-report/inventory-balance-report.component';
import { PurchaseReportComponent } from './reports/purchase-report/purchase-report.component';
import { ItemSalesReportComponent } from './reports/item-sales-report/item-sales-report.component';
import { ConsumptionReportComponent } from './reports/consumption-report/consumption-report.component';
import { FixedAssetReportComponent } from './reports/fixed-asset-report/fixed-asset-report.component';
import { BackupComponent } from './backup/backup.component';


import { ResetPasswordComponent } from './users/reset-password/reset-password/reset-password.component';
import { ResetPasswordListComponent } from './users/reset-password/reset-password-list/reset-password-list.component';
import { ResetPasswordRequestComponent } from './users/reset-password-request/reset-password-request.component';

//Services
import { CompanyProfileService} from './shared/services/company-profile.service';
import { CustomerService } from './shared/services/customer.service';
import { EmployeeService } from './shared/services/employee.service';
import { InvoiceService } from './shared/services/invoice.service';
import { AuthGuard } from './shared/guards/auth.guard';
import { UserService } from './shared/services/user.service';
import { AuthService } from './shared/services/auth.service';
import { AutoLogoutService } from './shared/services/auto-logout.service';


import { TokenInterceptorService  } from './shared/services/token-interceptor.service';
import { EnvServiceProvider } from './shared/services/env.service.provider';

//Directives
import { AllowNumberOnlyDirective } from './shared/guards/allow-number-only.directive';

import { SolarPowerComponent } from './administration/solor-power/solar-power/solar-power.component';
import { SolarPowerListComponent } from './administration/solor-power/solar-power-list/solar-power-list.component';
import { WaterMeterComponent } from './administration/water-meter/water-meter/water-meter.component';
import { WaterMeterListComponent } from './administration/water-meter/water-meter-list/water-meter-list.component';
import { BikeRentComponent } from './administration/bike-rent/bike-rent/bike-rent.component';
import { BikeRentListComponent } from './administration/bike-rent/bike-rent-list/bike-rent-list.component';
import { GeneratorUsageComponent } from './administration/generator-usage/generator-usage/generator-usage.component';
import { GeneratorUsageListComponent } from './administration/generator-usage/generator-usage-list/generator-usage-list.component';
import { DrawChequeComponent } from './banks/draw-cheque/draw-cheque/draw-cheque.component';
import { DrawChequeListComponent } from './banks/draw-cheque/draw-cheque-list/draw-cheque-list.component';
import { ServiceChargeReportComponent } from './reports/service-charge-report/service-charge-report.component';
import { GuestPurchaseComponent } from './sale/guest-purchase/guest-purchase/guest-purchase.component';
import { GuestPurchaseListComponent } from './sale/guest-purchase/guest-purchase-list/guest-purchase-list.component';
import { WaterTankComponent } from './administration/water-tank/water-tank/water-tank.component';
import { WaterTankListComponent } from './administration/water-tank/water-tank-list/water-tank-list.component';
import { KitchenStockComponent } from './kitchen-stocks/kitchen-stocks/kitchen-stock/kitchen-stock.component';
import { KitchenStockListComponent } from './kitchen-stocks/kitchen-stocks/kitchen-stock-list/kitchen-stock-list.component';
import { StockRequirementComponent } from './kitchen-stocks/stock-requirements/stock-requirement/stock-requirement.component';
import { StockRequirementListComponent } from './kitchen-stocks/stock-requirements/stock-requirement-list/stock-requirement-list.component';
import { AddStockComponent } from './kitchen-stocks/add-stock/add-stock/add-stock.component';
import { AddStockListComponent } from './kitchen-stocks/add-stock/add-stock-list/add-stock-list.component';
import { ConsumtionComponent } from './kitchen-stocks/consumption/consumtion/consumtion.component';
import { ConsumtionListComponent } from './kitchen-stocks/consumption/consumtion-list/consumtion-list.component';
import { KitchenStockBalComponent } from './kitchen-stocks/kitchen-stock-bal/kitchen-stock-bal.component';
import { AddStockItemsComponent } from './kitchen-stocks/add-stock/add-stock-items/add-stock-items.component';
import { AddConsumptionItemsComponent } from './kitchen-stocks/consumption/add-consumption-items/add-consumption-items.component';
import { AddStockRequirementItemsComponent } from './kitchen-stocks/stock-requirements/add-stock-requirement-items/add-stock-requirement-items.component';
import { AddStockRequirementComponent } from './kitchen-stocks/stock-requirements/add-stock-requirement/add-stock-requirement.component';












@NgModule({
  declarations: [
    AppComponent,
    PagesComponent,
    DashboardComponent,
    LoginComponent,
    MatConfirmDialogComponent,
    CompanyProfileComponent,

    AddCustomerComponent,
    AddSupplierComponent,
    ViewCustomersComponent,
    ViewSupplierComponent,
    AddInvoiceComponent,
    InvoiceListComponent,
    
    
    EmployeeComponent,
    EmployeeListComponent,
    FixedAssetComponent,
    FixedAssetListComponent,
    ItemComponent,
    ItemListComponent,
    UsersComponent,
    UserListComponent,
    UserTypesComponent,
    UserPermissionComponent,
    ItemCategoryComponent,
    ReceiptComponent,
    ReceiptListComponent,
    PurchaseOrderComponent,
    PurchaseOrderListComponent,
    PurchaseInvoiceComponent,
    PurchaseInvoiceListComponent,
    PaymentComponent,
    PaymentListComponent,
    ExpenseComponent,
    ExpenseListComponent,
    CustomerOutstandingReportComponent,
    SupplierOutstandingReportComponent,
    SalesReportComponent,
    IncomeStatementComponent,
    ExpensesAnalysisReportComponent,
    InventoryBalanceReportComponent,
    PurchaseReturnComponent,
    PurchaseReturnListComponent,
    SettingsComponent,
    QuotationComponent,
    QuotationListComponent,
    BankAccountsComponent,
    ChequeListComponent,
    CashFlowComponent,
    CashBankEntryComponent,
    CashBankEntryListComponent,
    PurchaseReportComponent,
    ChangePasswordComponent,
    BankAccountListComponent,
    FileUploadComponent,
   

    AllowNumberOnlyDirective,

    ItemSalesReportComponent,


     BackupComponent,
     ResetPasswordComponent,
     ResetPasswordListComponent,
     ResetPasswordRequestComponent,
     RoomDetailsComponent,
     RoomDetailsListComponent,
     VehicleRegisterComponent,
     VehicleRegisterListComponent,
     BarInvoiceComponent,
     BarInvoiceListComponent,
     SolarPowerComponent,
     SolarPowerListComponent,
     WaterMeterComponent,
     WaterMeterListComponent,
     BikeRentComponent,
     BikeRentListComponent,
     GeneratorUsageComponent,
     GeneratorUsageListComponent,
     DrawChequeComponent,
     DrawChequeListComponent,
     ServiceChargeReportComponent,
     GuestPurchaseComponent,
     GuestPurchaseListComponent,
     WaterTankComponent,
     WaterTankListComponent,
     KitchenStockComponent,
     KitchenStockListComponent,
     StockRequirementComponent,
     StockRequirementListComponent,
     AddStockComponent,
     AddStockListComponent,
     ConsumtionComponent,
     ConsumtionListComponent,
     KitchenStockBalComponent,
     AddStockItemsComponent,
     AddConsumptionItemsComponent,
     AddStockRequirementItemsComponent,
     AddStockRequirementComponent,
     ConsumptionReportComponent,
     FixedAssetReportComponent,
  ],

  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    MaterialModule,
    AppRoutingModule,
    FileUploadModule,
    ChartsModule,
    BsDatepickerModule.forRoot(),
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    NbChatModule.forRoot({
      messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
    }),
    CoreModule.forRoot(),
    NbCardModule,
    ThemeModule.forRoot(),
    ToastrModule.forRoot(),
    EditorModule

  ],
  providers: [
    CompanyProfileService,
    CustomerService,
    EmployeeService,
    InvoiceService,
    UserService,
    AuthService,
    AutoLogoutService,
    { 
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptorService, 
      multi: true 
    },
    AuthGuard,
    EnvServiceProvider,
    DecimalPipe
   
  
    
    ],
  bootstrap: [AppComponent],
  entryComponents:[
    MatConfirmDialogComponent,
    UsersComponent,
    CashBankEntryComponent,
    BankAccountsComponent,
    FileUploadComponent,
   ],
})
export class AppModule {
}
